import { useEffect, useRef, type ComponentType } from "react";
import BandsIntro from "./BandsIntro";
import BriefingIntro from "./BriefingIntro";
import CardsIntro from "./CardsIntro";
import styles from "./StageIntro.module.css";
import type { StageIntroVariantProps } from "./types";

export type StageIntroVariant = "cards" | "briefing" | "bands";

const variants: Record<StageIntroVariant, ComponentType<StageIntroVariantProps>> = {
  cards: CardsIntro,
  briefing: BriefingIntro,
  bands: BandsIntro,
};

/** Design patterns are compared with ?intro=cards|briefing|bands. */
export function readIntroVariant(): StageIntroVariant {
  const value = new URLSearchParams(window.location.search).get("intro");
  return value && value in variants ? value as StageIntroVariant : "briefing";
}

export default function StageIntro({ variant, onDismiss, ...props }: StageIntroVariantProps & { variant: StageIntroVariant; onDismiss: () => void }) {
  const rootRef = useRef<HTMLDivElement>(null);
  const Variant = variants[variant];

  useEffect(() => {
    rootRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === " " || event.key === "Escape") { event.preventDefault(); onDismiss(); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onDismiss]);

  return (
    <div ref={rootRef} className={styles.root} role="dialog" aria-modal="true" aria-label={`${props.stageLabel} の3つの条件`} tabIndex={-1}
      onClick={onDismiss}>
      <Variant {...props} />
      <p className={styles.hint}>画面をタップしてスタート</p>
    </div>
  );
}
